export default "__VITE_ASSET__Dhdjz1f___"